import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Role, RoleModel } from '../../../services/RoleModel';
import { DateUtil } from '../../../util/DateUtil';
import { PersonDisplayUtil } from '../../../util/PersonDisplayUtil';
import { roleHasEnd } from './roles-view-model';

/**
 * Gemeinsame Anzeige-Helfer (Labels/Farben) für die zusätzlichen Personen-Ansichten
 * (Verlauf + Zeitstrahl) — vermeidet Duplikation zwischen den Komponenten.
 */
@Injectable({ providedIn: 'root' })
export class RolesDisplayService {
	private readonly transloco = inject(TranslocoService);
	private readonly dateUtil = inject(DateUtil);
	private readonly personDisplay = inject(PersonDisplayUtil);

	roleTypeLabel(roleType: string | null | undefined): string {
		if (!roleType) {
			return '-';
		}
		const rolesViewKey = `tenantunitDetails.rolesView.roleTypes.${roleType}`;
		const rolesViewLabel = this.transloco.translate(rolesViewKey);
		if (rolesViewLabel !== rolesViewKey) {
			return rolesViewLabel;
		}
		const enumKey = `enum.${roleType}`;
		const enumLabel = this.transloco.translate(enumKey);
		return enumLabel === enumKey ? roleType.toString() : enumLabel;
	}

	personName(roleModel: RoleModel): string {
		if (roleModel.isVacancy) {
			return this.transloco.translate('enum.VACANCY');
		}
		return this.personDisplay.getLongName(roleModel.person);
	}

	periodLabel(role: Role): string {
		const from = role.validFrom ? this.dateUtil.checkDateValid(role.validFrom) : '–';
		const to = roleHasEnd(role) ? this.dateUtil.checkDateValid(role.validTo) : '∞';
		return `${from} – ${to}`;
	}
}
